import { type FormEvent, useState } from 'react';
import { ApiError, errorMessage, post } from '../api/client';
import { useMe } from '../auth';
import { Field, PageHead, useFeedback } from '../components/ui';
import { useT } from '../i18n';

export function Account() {
  const { t } = useT();
  const { data: me } = useMe();
  const { toast } = useFeedback();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<ApiError | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== repeat) return setError(new ApiError(400, t('Las dos contraseñas nuevas no coinciden')));
    setBusy(true);
    setError(null);
    try {
      await post('/admin/auth/password', { current, next });
      setCurrent('');
      setNext('');
      setRepeat('');
      toast(t('Contraseña cambiada. Se cerraron tus otras sesiones.'));
    } catch (err) {
      setError(err instanceof ApiError ? err : new ApiError(0, errorMessage(err)));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHead kicker={t('Mi cuenta')} title={me?.name ?? ''} description={`${me?.email} · ${me?.role === 'ADMIN' ? t('Administrador') : t('Editor')}`} />
      <form className="panel panel-pad stack" style={{ maxWidth: 460 }} onSubmit={submit}>
        <h2 className="section-title">{t('Cambiar contraseña')}</h2>
        {error && !error.errors.length && <div className="notice error">{error.message}</div>}
        <Field label={t('Contraseña actual')} error={error?.field('current')}>
          {(id) => <input id={id} type="password" className="input" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />}
        </Field>
        <Field label={t('Nueva contraseña')} hint={t('Mínimo 10 caracteres')} error={error?.field('next')}>
          {(id) => <input id={id} type="password" className="input" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required />}
        </Field>
        <Field label={t('Repite la nueva contraseña')}>
          {(id) => <input id={id} type="password" className="input" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />}
        </Field>
        <div>
          <button className="btn btn-primary" disabled={busy}>
            {busy ? t('Guardando…') : t('Cambiar contraseña')}
          </button>
        </div>
      </form>
    </>
  );
}
